import {
  BranchesOutlined,
  EyeOutlined,
  FilterOutlined,
  SortAscendingOutlined,
} from "@ant-design/icons";
import {  Col, Divider, Drawer, Typography } from "antd";
import { useState } from "react";
import TreeCategories from "./TreeCategories";
import MobileFilters from "./MobileFilters";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import MobileViewingModes from "./MobileViewingMode";
import SaveFilterDataButton from "./SaveFilterDataButton";
import MobileSorting from "./MobileSorting";

const MobileTopOptions = () => {
  const [isShowSortingDrawer, setIsShowSortingDrawer] = useState(false);
  const [isShowViewingDrawer, setIsShowViewingDrawer] = useState(false);
  const { Text } = Typography;
  const [isShowCategoryDrawer, setIsShowCategoryDrawer] = useState(false);
  const [isShowFilterDrawer, setIsShowFilterDrawer] = useState(false);
  const { filter } = useSelector((state: RootState) => state.realState);
  const isShowSaveFilter = Object.entries(filter).length > 13;
  return (
    <>
      <div className={` flex items-center justify-between bg-gray-100 p-2`}>
        <div
          onClick={() => {
            setIsShowCategoryDrawer(true);
          }}
          className={` text-black   !bg-transparent  !cursor-pointer `}
        >
          <BranchesOutlined className="!text-xs" />
          <Text className="!text-xs"> Kategory Seç </Text>
        </div>
        <Divider type="vertical" className="h-6 !m-0" />
        <div
          onClick={() => {
            setIsShowFilterDrawer(true);
          }}
          className={` text-black   !bg-transparent  !cursor-pointer `}
        >
          <FilterOutlined className="!text-xs" />
          <Text className="!text-xs"> Filtrele </Text>
        </div>
        <Divider type="vertical" className="h-6 !m-0" />
        <div
          onClick={() => {
            setIsShowViewingDrawer(true);
          }}
          className={` text-black   !bg-transparent  !cursor-pointer `}
        >
          <EyeOutlined className="!text-xs" />
          <Text className="!text-xs"> Görünüm </Text>
        </div>
        <Divider type="vertical" className="h-6 !m-0" />
        <div
          onClick={() => {
            setIsShowSortingDrawer(true);
          }}
          className={` text-black   !bg-transparent  !cursor-pointer `}
        >
          <SortAscendingOutlined className="!text-xs" />
          <Text className="!text-xs"> Sıralama </Text>
        </div>
      </div>
      {isShowSaveFilter && (
        <div className="!mt-4 ">
          <SaveFilterDataButton />
        </div>
      )}
      <Drawer
        title="Kategory Seç"
        bodyStyle={{ background: "white" }}
        open={isShowCategoryDrawer}
        onClose={() => {
          setIsShowCategoryDrawer(false);
        }}
      >
        <TreeCategories wrapperClasName="!border-none" />
      </Drawer>

      <Drawer
        title="İlanları Filtrele"
        open={isShowFilterDrawer}
        onClose={() => {
          setIsShowFilterDrawer(false);
        }}
      >
        <MobileFilters
          onFinish={() => {
            setIsShowCategoryDrawer(false);
          }}
        />
      </Drawer>
      <Drawer
        title="Görünüm Modu Seç"
        open={isShowViewingDrawer}
        onClose={() => {
          setIsShowViewingDrawer(false);
        }}
      >
        <div className="">
          <MobileViewingModes />
        </div>
      </Drawer>
      <Drawer
        title="Sıralamayı Seç"
        open={isShowSortingDrawer}
        onClose={() => {
          setIsShowSortingDrawer(false);
        }}
      >
        <Col xs={24}>
          <MobileSorting />
        </Col>
      </Drawer>
    </>
  );
};

export default MobileTopOptions;
